// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConnectionMonitorController from "./connection_monitor_controller"
application.register("connection-monitor", ConnectionMonitorController)

import SwapController from "./swap_controller"
application.register("swap", SwapController)

import GuessAssignmentController from "./guess_assignment_controller"
application.register("guess-assignment", GuessAssignmentController)

import SpymasterKeyController from "./spymaster_key_controller"
application.register("spymaster-key", SpymasterKeyController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DialController from "./dial_controller"
application.register("dial", DialController)

import Dialog from '@stimulus-components/dialog'
application.register('dialog', Dialog)

import RevealController from '@stimulus-components/reveal'
application.register('reveal', RevealController)
